// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2ticp","footer":"ChangeClinic_footer__1tXYb"};